import { businessKey } from 'queryKeys';

const MASTER_CAMPAIGNS = 'masterCampaigns';
const MUTATION_IMPORT = 'import';
const MUTATION_UPLOAD = 'upload';
const MUTATION_START_UPLOAD = 'startUpload';
const mcQuery = businessKey.query(MASTER_CAMPAIGNS);

export const model = mcQuery.exact();
export const details = mcQuery.details();
export const grids = mcQuery.grids();
export const grid = mcQuery.grid();

export const mutations = mcQuery.mutations();

export const create = mutations.create();
export const remove = mutations.delete();
export const update = mutations.update();
export const upload = mutations.mutate(MUTATION_UPLOAD);

export const importMC = mutations.mutate(MUTATION_IMPORT);
export const startUpload = mutations.mutate(MUTATION_START_UPLOAD);
